import { RefObject, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { notification } from "@sol/uikit/feedback/Notification/Notification";
type ApiErrorAlertProps = {
    error: any;
    dissmiss?: () => void;
    triggerElement?: RefObject<HTMLElement | undefined>;
};

const ApiErrorAlert = ({ error, dissmiss, triggerElement }: ApiErrorAlertProps) => {
    const [t] = useTranslation();
    const [api, contextHolder] = notification.useNotification();

    const data = error?.response?.data || error?.data;
    const violations = data?.violations;
    const text: string = (((violations?.length || 0) > 0 && violations[0].message) ||
        data?.["hydra:description"] ||
        data?.message ||
        t("component.ApiErrorAlert.defaultText")) as string;

    // Callers often pass an inline callback: following its identity would repeat the notice on every render
    const dismissRef = useRef(dissmiss);
    dismissRef.current = dissmiss;

    useEffect(() => {
        if (error) {
            api.error({
                message: text,
                closable: dismissRef.current !== null,
                onClose: () => {
                    dismissRef.current?.();

                    if (triggerElement) {
                        triggerElement.current?.focus();
                    }
                },
                duration: 5,
            });
        }
    }, [error, api, text, triggerElement]);

    return <>{contextHolder}</>;
};

export default ApiErrorAlert;
